(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('PolicyRuleEditController', ["$scope", "$q", "$routeParams", "$route", "policyDao", "routeHelper", "policyRuleConfig", "policyRulesDao", "errorStatusHolder", "modals", "severityTypes", "modulesDao", "policyRuleModes", "feature", "$location", "$timeout", "appConfigurator", "alertReceiversModal", "sideMenuManager", "configDao", "troubleshooting", "countries", "licensesDao", "path", "modulePropsToOptions", "modulesManager", "encryptionService", function ($scope, $q, $routeParams, $route, policyDao, routeHelper, policyRuleConfig, policyRulesDao, errorStatusHolder, modals, severityTypes, modulesDao, policyRuleModes, feature, $location, $timeout, appConfigurator, alertReceiversModal, sideMenuManager, configDao, troubleshooting, countries, licensesDao, path, modulePropsToOptions, modulesManager, encryptionService) {
        var saasApps = [];
        var securityApps = [];
        var workflowsMissingConfig = {};
        var saasConfig;
        var scopeExcludedEmails = [];
        $scope.loading = true;
        $scope.filterBy = '';
        $scope.loadingScopes = true;
        $scope.enabledScope = false;
        $scope.savingConfig = false;
        $scope.savingConfigTip = {};
        $scope.disableEncryptionWorkflowModal = false;
        $scope.userIsAdmin = sideMenuManager.currentUser().admin;
        $scope.cancelHref = routeHelper.getHref('policy-rules');
        $scope.ruleStates = policyRuleConfig.ruleStates();
        $scope.workflows = [];
        $scope.severityTypes = angular.copy(severityTypes.data);
        $scope.severityTypes.unshift({
            autoId: 'policy_rule_edit_severity_dropdown_item_auto',
            id: 'auto',
            label: 'Auto'
        });
        var defaultSeverity = 'auto';
        $scope.severityTooltip = {
            content: { text: 'Events generated by this rule will have that severity' },
            position: {
                my: 'left center',
                at: 'right center'
            },
            style: {
                classes: 'rule-edit-qtip severity-tip',
                tip: {
                    width: 14,
                    height: 8,
                    corner: true
                }
            }
        };
        $scope.betaTooltip = {
            content: { text: 'This app is in beta mode. It will not trigger any actions' },
            position: {
                at: 'top center',
                my: 'bottom center'
            },
            style: { classes: 'qtip-standard beta-tooltip' }
        };
        $scope.dlpSensitivityOptions = {
            autoId: 'policy_rule_edit_dlp_sensitivity_dropdown',
            defaultTooltip: true,
            tooltip: formatStaticPhishingTooltip('Sensitivity level defines which items will be handled by this rule. <br />Items with higher hit count will be caught on lower sensitivity levels.')
        };
        $scope.dlpSensitivities = [
            {
                autoId: 'policy_rule_edit_dlp_sensitivity_dropdown_item_1',
                id: 1,
                label: 'Very High (hit count >0)'
            },
            {
                autoId: 'policy_rule_edit_dlp_sensitivity_dropdown_item_2',
                id: 2,
                label: 'High (hit count >2)'
            },
            {
                autoId: 'policy_rule_edit_dlp_sensitivity_dropdown_item_5',
                id: 5,
                label: 'Medium (hit count >5)'
            },
            {
                autoId: 'policy_rule_edit_dlp_sensitivity_dropdown_item_10',
                id: 10,
                label: 'Low (hit count >10)'
            },
            {
                autoId: 'policy_rule_edit_dlp_sensitivity_dropdown_item_20',
                id: 20,
                label: 'Very Low (hit count >20)'
            }
        ];
        var displayLimitedLicensePopupFor = [
            'office365_emails',
            'google_mail'
        ];
        var didDisplayLimitedLicensePopup = false;
        function adjustDlpSensitivity(value) {
            var result = -1;
            if (!value) {
                return $scope.dlpSensitivities[0].id;
            }
            _($scope.dlpSensitivities).find(function (variant) {
                if (result === -1 || variant.id <= value) {
                    result = variant.id;
                }
                if (variant.id >= value) {
                    return true;
                }
            });
            return result;
        }
        $scope.model = { disableOnClickItem: ['is_quarantine_user'] };
        $scope.internal = {
            selectedApps: {},
            workflows: {},
            actions: {},
            dlpSecTool: ''
        };
        $scope.countriesList = _(countries.list()).map(function (info) {
            return {
                autoId: 'policy_rule_edit_countries_dropdown_item_' + info.isoCode,
                id: info.isoCode,
                label: info.name
            };
        });
        $scope.devicesTypes = [
            {
                id: 'corporate',
                label: 'Allow access only from corporate devices'
            },
            {
                id: 'compliant',
                label: 'Allow only compliant devices'
            },
            {
                id: 'all',
                label: 'Allow all devices'
            }
        ];
        $scope.enableProtectOutgoingEmails = false;
        function loadApps() {
            return modulesManager.init().then(function () {
                saasApps = _(modulesManager.allCloudApps()).chain().filter(function (app) {
                    return app.state !== 'display_only' && app.isSaas;
                }).sortBy('security_stack_order').sortBy(function (app) {
                    return app.state === 'active' ? 1 : 2;
                }).value();
                securityApps = _(modulesManager.allSecApps()).chain().filter(function (app) {
                    return app.state !== 'display_only' && !app.is_saas && !app.hidden_from_rules;
                }).sortBy('security_stack_order').value();
                $scope.activeAppsBySecType = {};
                _([
                    'av',
                    'ap',
                    'dlp'
                ]).each(function (secType) {
                    $scope.activeAppsBySecType[secType] = _(securityApps).filter(function (app) {
                        // show dlp2 for only debug mode
                        if (secType === 'dlp' && app.name === 'dlp_checkpoint2') {
                            return troubleshooting.entityDebugEnabled();
                        }
                        return app.sec_type === secType && app.state === 'active';
                    });
                });
                $scope.saasList = _(saasApps).map(function (app) {
                    return {
                        autoId: 'policy_rule_create_saas_dropdown_item_' + app.name,
                        id: app.name,
                        label: app.label,
                        disabled: app.state !== 'active'
                    };
                });
                var isActiveCTProtection = modulesManager.activeSecApps().includes('clicktime_protection');
                var dumpRuleTypes = _(policyRuleConfig.ruleTypes()).map(function (ruleType) {
                    if (feature.showClicktimeProtection && ruleType.id === 'clicktime_protection') {
                        ruleType.hidden = !isActiveCTProtection;
                    }
                    return ruleType;
                });
                policyRuleConfig.ruleTypes(dumpRuleTypes);
            });
        }
        function loadActions(saas, skipInit) {
            return policyRulesDao.ruleActions(saas).then(function (response) {
                $scope.actions = response.data && _(response.data).sortBy(function (action) {
                    return action && action.id;
                });
                $scope.actionsMap = _($scope.actions).chain().map(function (action) {
                    return [
                        action.id,
                        action
                    ];
                }).object().value();
                if (!skipInit) {
                    $scope.internal.actions = {};
                }
            });
        }
        function idToLabel(id) {
            id = id.replace(/_/g, ' ');
            return id.toUpperCase();
        }
        function makeDLPTree(data) {
            var categories = [];
            _(data).each(function (val, k) {
                var sub_item;
                var tooltipContent = '<strong>' + k + '</strong><br/><br/>' + val.html_tooltip;
                var tooltip = {
                    content: { text: tooltipContent },
                    position: {
                        my: 'left center',
                        at: 'right center'
                    },
                    style: { classes: 'qtip-standard qtip-dlp-rules' }
                };
                if (val.parent) {
                    var parentIndex = _(categories).findIndex(function (obj) {
                        return obj.id === val.parent;
                    });
                    if (parentIndex !== -1) {
                        if (!categories[parentIndex].items) {
                            categories[parentIndex].items = [];
                        }
                        categories[parentIndex].items.push({
                            id: k,
                            label: k,
                            tooltip: tooltip
                        });
                    } else {
                        sub_item = {
                            id: val.parent,
                            label: val.parent,
                            items: []
                        };
                        sub_item.items.push({
                            id: k,
                            label: k,
                            tooltip: tooltip
                        });
                        categories.push(sub_item);
                    }
                } else {
                    var index = _(categories).findIndex(function (obj) {
                        return obj.id === k;
                    });
                    if (index !== -1) {
                        categories[index].tooltip = tooltip;
                    } else {
                        categories.push({
                            id: k,
                            label: k,
                            tooltip: tooltip
                        });
                    }
                }
            });
            return _.sortBy(categories, 'id');
        }
        function loadDlpRules() {
            if (feature.checkpointTheme) {
                return policyRulesDao.toolSpecificRule('dlp_checkpoint').then(function (response) {
                    $scope.toolSpecificRules = makeDLPTree(response.data);
                });
            }
            return policyRulesDao.dlpRules().then(function (response) {
                $scope.dlpRules = _(response.data.normalized_rules).map(function (rule) {
                    return {
                        id: rule,
                        label: rule
                    };
                });
            });
        }
        $scope.onFilterByChange = function (searchTxt) {
            $scope.filterBy = searchTxt;
        };
        function saasConfigConverter(response) {
            if (response && response.data) {
                saasConfig = response.data;
                scopeExcludedEmails = [];
                _(saasConfig).each(function (param) {
                    if (param.is_quarantine_email && param.value) {
                        scopeExcludedEmails.push(param.value);
                    }
                });
            }
            return $q.when(response);
        }
        function loadAnomalyTypes() {
            return policyRulesDao.anomalyTypes().then(function (response) {
                $scope.anomalyTypes = response.data;
            });
        }
        function formatStaticPhishingTooltip(text) {
            if (!text) {
                return;
            }
            return {
                content: { text: text },
                position: {
                    at: 'right center',
                    my: 'left center'
                },
                style: {
                    classes: 'rule-edit-qtip',
                    tip: {
                        width: 14,
                        height: 8,
                        corner: true
                    }
                }
            };
        }
        function loadStaticPhishingTypes() {
            return policyRulesDao.staticPhishingTypes().then(function (response) {
                if (!_(response.data).isEmpty()) {
                    $scope.staticPhishingOptions = {
                        autoId: 'policy_rule_edit_workflow_static_phishing_dropdown',
                        multiple: true,
                        emptyLabel: response.data.emptyLabel || 'Nothing',
                        tooltip: formatStaticPhishingTooltip(response.data.tooltip),
                        controlLabel: response.data.label
                    };
                    $scope.staticPhishingTypes = _(response.data.options).chain().map(function (option, id) {
                        return {
                            autoId: 'policy_rule_edit_workflow_static_phishing_dropdown_item_' + id,
                            id: id,
                            label: option.label,
                            order: option.order,
                            tooltip: formatStaticPhishingTooltip(option.tooltip)
                        };
                    }).sortBy('order').value();
                }
            });
        }
        function loadSaasConfig(saas) {
            return modulesDao.retrieveConfig(saas).converter(saasConfigConverter).onRequestFail(function () {
                return $q.when({ data: {} });
            });
        }
        function loadManualMailflowConfig() {
            return modulesDao.retrieveConfig('office365_auth').converter(saasConfigConverter).onRequestFail(function () {
                return $q.when({ data: {} });
            });
        }
        function loadPolicyScopes(saas, params) {
            return policyDao.saasIdentities(saas, params).converter(function (input) {
                return modulesDao.retrieveConfig(saas).then(function (res) {
                    _(res.data).each(function (param) {
                        if (param.is_quarantine_email && param.value) {
                            var findQuarantineUser = _(input.data.rows).findIndex(function (user) {
                                return user.gui_sub_label === param.value;
                            });
                            if (findQuarantineUser !== -1) {
                                input.data.rows[findQuarantineUser].is_quarantine_user = true;
                            }
                        }
                    });
                    return $q.when(input);
                }).catch(function () {
                    return $q.when(input);
                });
            });
        }
        function generateWorkflows(config, mode) {
            workflowsMissingConfig = {};
            $scope.workflowConfigs = {};
            $scope.showStaticPhishing = {};
            $scope.workflows = [];
            _($scope.ruleTypeConfig.workflows).each(function (src) {
                if (!config[src.id] || !config[src.id].variants || !config[src.id].variants.length || !($scope.model.saas === 'office365_emails' || $scope.model.saas === 'google_mail') && src.moduleName === 'cp_threat_extraction') {
                    return;
                }
                var workflow = angular.copy(_(src).omit('variants'));
                workflowsMissingConfig[workflow.id] = {};
                $scope.workflowConfigs[workflow.id] = {};
                $scope.showStaticPhishing[workflow.id] = {};
                workflow.variants = config[workflow.id].variants;
                workflow.variants[0].default = true;
                workflow.variants = _(workflow.variants).filter(function (variant) {
                    if (variant.rule_require) {
                        var faulty = _(variant.rule_require).find(function (check) {
                            if (check.param && check.notEmpty && config[check.param]) {
                                return !config[check.param].value || _(config[check.param].value).isArray() && !config[check.param].value.length;
                            }
                        });
                        if (faulty) {
                            workflowsMissingConfig[workflow.id][variant.id] = faulty.error_message || 'Selected workflow missing required configuration';
                        }
                    }
                    if (variant.rule_edit_config) {
                        $scope.workflowConfigs[workflow.id][variant.id] = variant.rule_edit_config;
                    }
                    if (feature.staticPhishing && variant.rule_show_static_phishing) {
                        $scope.showStaticPhishing[workflow.id][variant.id] = true;
                    }
                    variant.autoId = 'policy_rule_edit_workflow_' + workflow.id + '_dropdown_item_' + variant.id.toString();
                    if ($scope.model.ruleType === 'dlp' && variant.id.indexOf('_encryption') !== -1 && typeof enableEncryption !== 'undefined' && !enableEncryption) {
                        variant.disabled = true;
                        variant.tooltip = 'There are no O365 users with license eligible for encryption. Please consult the O365 pricing plans on the minimal license requirements';
                    }
                    // supports the following workflows for MS encryption:
                    // - microsoft_encryption
                    // - user_microsoft_encryption
                    // - admin_microsoft_encryption
                    var encryption_module_name = variant.id;
                    if (encryption_module_name && _(encryption_module_name).isString() && encryption_module_name.indexOf('microsoft_encryption') !== -1) {
                        encryption_module_name = 'microsoft_encryption';
                    }
                    if (modulesManager.app(encryption_module_name) && !modulesManager.isActive(encryption_module_name)) {
                        return false;
                    }
                    if (variant.feature && !feature[variant.feature]) {
                        return false;
                    }
                    if (mode && variant.mode && variant.mode.indexOf(mode) === -1) {
                        return false;
                    }
                    return true;
                });
                $scope.workflows.push(workflow);
            });
        }
        function loadWorkflows(saas, config, rule) {
            var q;
            if ($scope.model.ruleType === 'dlp') {
                var enableEncryption = false;
                q = $q.when();
                q = q.then(function () {
                    return encryptionService.getEncryptionStatus();
                }).then(function (res) {
                    enableEncryption = res.data;
                    if (config) {
                        return config;
                    } else {
                        return modulesDao.retrieveConfig(saas).converter(saasConfigConverter);
                    }
                }, function () {
                    enableEncryption = false;
                    if (config) {
                        return config;
                    } else {
                        return modulesDao.retrieveConfig(saas).converter(saasConfigConverter);
                    }
                });
            } else {
                if (config) {
                    q = $q.when(config);
                } else {
                    q = modulesDao.retrieveConfig(saas).converter(saasConfigConverter);
                }
            }
            return q.then(function (response) {
                var config = response.data;
                saasConfig = config;
                $scope.saasConfig = config;
                var currentMode = $scope.model && $scope.model.mode;
                if (!currentMode) {
                    if (rule && _($scope.modes).find(function (mode) {
                            return mode.id === rule.mode;
                        })) {
                        currentMode = rule.mode;
                    } else {
                        currentMode = $scope.ruleTypeConfig.defaultMode;
                    }
                }
                generateWorkflows(config, currentMode);
            });
        }
        function loadDeploymentConfig() {
            if (feature.sonicwallTheme || feature.checkpointTheme || feature.lastlineTheme) {
                $scope.maxInlineUsers = null;
            } else {
                return $q.all([
                    configDao.param('max_inline_users'),
                    configDao.param('deployment_mode')
                ]).then(function (responses) {
                    var maxInlineUsers = responses[0];
                    var deploymentMode = responses[1];
                    if (deploymentMode === 'poc') {
                        $scope.maxInlineUsers = _(maxInlineUsers).isNull() ? 5 : maxInlineUsers;
                    } else {
                        $scope.maxInlineUsers = null;
                    }
                });
            }
        }
        function initializeDetailsView(rule) {
            // register ui_features to scope
            $scope.model.inlineDLPSubjectRegex = feature.inlineDLPSubjectRegex;
            if (rule) {
                $scope.model.saas = rule.saas;
                $scope.model.ruleType = policyRuleConfig.localRuleType(rule.saas, rule.type);    // if(rule.system && !troubleshooting.entityDebugEnabled()) {
                                                                                                 //     routeHelper.redirectTo('dashboard');
                                                                                                 // }
            }
            if ($scope.model.saas === 'slack' && feature.enableSlackFeatures) {
                $scope.enabledScope = !!feature.enableSlackPolicyScope;
            } else if ($scope.model.saas === 'ms_teams') {
                $scope.enabledScope = !!feature.enableTeamsScope;
            } else {
                $scope.enabledScope = true;
            }
            var saasApp = _(saasApps).find(function (app) {
                return app.name === $scope.model.saas;
            });
            $scope.ruleTypeConfig = policyRuleConfig.ruleTypeConfig($scope.model.saas, $scope.model.ruleType, securityApps);
            // overwrite activeAppsBySecType
            if ($scope.ruleTypeConfig.overwrite && $scope.ruleTypeConfig.overwrite[$scope.model.saas] && $scope.ruleTypeConfig.overwrite[$scope.model.saas].availableApps) {
                var newActiveAppsBySecType = {};
                _($scope.activeAppsBySecType).each(function (apps, secType) {
                    newActiveAppsBySecType[secType] = [];
                    if ($scope.ruleTypeConfig.overwrite[$scope.model.saas].availableApps[secType]) {
                        newActiveAppsBySecType[secType] = _(apps).filter(function (app) {
                            return $scope.ruleTypeConfig.overwrite[$scope.model.saas].availableApps[secType].indexOf(app.name) !== -1;
                        });
                    } else {
                        newActiveAppsBySecType[secType] = apps;
                    }
                });
                $scope.activeAppsBySecType = newActiveAppsBySecType;
            }
            if (!saasApp || !$scope.ruleTypeConfig) {
                if (rule) {
                    errorStatusHolder.errorStatus(500);
                }
                return;
            }
            if ($scope.ruleTypeConfig.id === 'custom') {
                routeHelper.redirectTo('policy-create', { saas: $scope.model.saas });
                return;
            }
            $scope.modes = $scope.ruleTypeConfig.modes;
            if (!$scope.ruleTypeConfig.activeSecTypes) {
                modals.alert('No security tools required for this type of rule is running.', { title: 'Error' }).finally(function () {
                    routeHelper.redirectTo('policy-rules');
                });
                return;
            }
            var ruleTypeName = saasApp.label + ' ' + $scope.ruleTypeConfig.label;
            if (rule) {
                $scope.pageTitle = $scope.pageTitlePrefix + ' - ' + ruleTypeName;
            }
            $scope.noAppSelector = !$scope.ruleTypeConfig.appSelector;
            var queries = [];
            var saasConfigQuery = loadSaasConfig($scope.model.saas);
            if ($scope.ruleTypeConfig.singleRule && !rule) {
                queries.push(policyRulesDao.list().params({
                    filterEnum_saas: $scope.model.saas,
                    filterEnum_type: $scope.ruleTypeConfig.backendType
                }).pagination(0, 1).then(function (response) {
                    if (!response.data.rows.length) {
                        return;
                    }
                    return modals.confirm({
                        title: 'Rule already exists',
                        message: 'Selected rule type already exists, do you want to edit existing rule?'
                    }).then(function () {
                        routeHelper.redirectTo('policy-rule-edit', { id: response.data.rows[0].id });
                        return $q.reject();
                    }, function () {
                        routeHelper.redirectTo('policy-rules');
                        return $q.reject();
                    });
                }));
            }
            queries.push(loadActions($scope.model.saas));
            if ($scope.ruleTypeConfig.activeSecTypes.dlp) {
                queries.push(loadDlpRules());
            }
            if ($scope.ruleTypeConfig.activeSecTypes.anomaly) {
                queries.push(loadAnomalyTypes());
            }
            if (_($scope.ruleTypeConfig.sec_types).includes('ap')) {
                queries.push(loadStaticPhishingTypes());
            }
            if ($scope.ruleTypeConfig.workflows) {
                queries.push(saasConfigQuery.then(function (response) {
                    return loadWorkflows($scope.model.saas, response, rule);
                }));
            }
            $scope.maxInlineUsers = null;
            if (_($scope.ruleTypeConfig.modes).find(function (mode) {
                    return mode.id === 'inline';
                })) {
                loadDeploymentConfig();
            }
            if ($scope.model.saas.indexOf('office365') !== -1) {
                queries.push(loadManualMailflowConfig().then(function (response) {
                    if (response.data.manual_mailflow_config && response.data.manual_mailflow_config.value === true) {
                        $scope.model.isManualMailflow = true;
                    } else {
                        $scope.model.isManualMailflow = false;
                    }
                }));
            }
            // check existing o365_emails dlp rules to detect if encryption workflow was created.
            // it will make sure that the encryption modal will be shown only one time at first creating.
            if ($scope.model.saas === 'office365_emails' && $scope.model.ruleType === 'dlp') {
                policyRulesDao.list().params({
                    filterEnum_saas: 'office365_emails',
                    filterEnum_type: 'dlp',
                    filterEnum_state: 'running,pause'
                }).pagination(0, 20).then(function (response) {
                    if (response.data && response.data.rows && response.data.rows.length) {
                        var foundEncryptionRule = _(response.data.rows).findIndex(function (row) {
                            if (row.mode === 'inline' && row.rule && row.rule.workflows) {
                                var foundEncryptionWf = false;
                                _(row.rule.workflows).each(function (workflow) {
                                    if (workflow.indexOf('_encryption') !== -1) {
                                        foundEncryptionWf = true;
                                    }
                                });
                                return foundEncryptionWf;
                            }
                            return false;
                        });
                        if (foundEncryptionRule !== -1) {
                            $scope.disableEncryptionWorkflowModal = true;
                        }
                    }
                });
            }
            return $q.all(queries).then(function () {
                $scope.loading = false;
                $scope.step = 'details';
                $scope.pageTitle = $scope.pageTitlePrefix + ' - ' + ruleTypeName;
                $scope.model.name = rule && rule.name || ruleTypeName;
                $scope.model.state = rule && rule.state || 'running';
                if ($scope.ruleTypeConfig.disableIdentities || $scope.model.saas === 'slack' && !feature.enableSlackPolicyScope || $scope.model.saas === 'ms_teams' && !feature.enableTeamsScope) {
                    $scope.scopesAvailable = false;
                    $scope.model.all = true;
                    $scope.loadingScopes = false;
                } else {
                    saasConfigQuery.then(function () {
                        return checkScopes($scope.model.saas, rule);
                    });
                }
                if (rule) {
                    $scope.model.rule = _(rule.rule).pick('dlp_rules', 'subject_regex', 'tool_specific_rules', 'active_anomalies', 'minimum_hit_count', 'static_phishing', 'skip_internal', 'allow_countries', 'allow_ips', 'block_countries', 'block_ips', 'devices', 'all_anomalies', 'excluded_anomalies', 'manual_inline_rule', 'active_sectools', 'selected_entities', 'ignore_low_confidence_results', 'protect_outgoing_emails');
                    if ($scope.model.rule.subject_regex && rule.mode === 'inline' && feature.inlineDLPSubjectRegex) {
                        $scope.model.useRegex = true;
                    }
                    if ($scope.ruleTypeConfig.activeSecTypes.anomaly) {
                        if ($scope.model.rule.active_anomalies) {
                            $scope.internal.selectedAnomalies = $scope.model.rule.active_anomalies;
                            $scope.model.rule.all_anomalies = false;
                        } else {
                            $scope.internal.selectedAnomalies = _($scope.anomalyTypes).chain().pluck('id').filter(function (id) {
                                return $scope.model.rule.all_anomalies || !$scope.model.rule.excluded_anomalies || !_($scope.model.rule.excluded_anomalies).includes(id);
                            }).value();
                        }
                    }
                    if ($scope.ruleTypeConfig.activeSecTypes.dlp) {
                        if (_($scope.model.rule.dlp_rules).findIndex(function (dlp_rule) {
                                return dlp_rule === 'sectool_managed';
                            }) !== -1 && _($scope.activeAppsBySecType.dlp).findIndex(function (app) {
                                return app.name === 'dlp_checkpoint2';
                            })) {
                            $scope.internal.dlpSecTool = 'dlp_checkpoint2';
                        } else if ($scope.model.rule.active_sectools && $scope.model.rule.active_sectools.any && $scope.model.rule.active_sectools.any.length) {
                            $scope.internal.dlpSecTool = $scope.model.rule.active_sectools.any[0];
                        }
                    }
                } else {
                    $scope.model.rule = {};
                    if ($scope.ruleTypeConfig.activeSecTypes.dlp) {
                        if (!feature.checkpointTheme) {
                            $scope.model.rule.dlp_rules = policyRuleConfig.allDlpRules($scope.dlpRules);
                        }
                        if (!$scope.internal.dlpSecTool && $scope.activeAppsBySecType.dlp && $scope.activeAppsBySecType.dlp.length) {
                            $scope.internal.dlpSecTool = $scope.activeAppsBySecType.dlp[0].name;
                        }
                    }
                    if ($scope.ruleTypeConfig.activeSecTypes.anomaly) {
                        $scope.model.rule.all_anomalies = true;
                        $scope.internal.selectedAnomalies = _($scope.anomalyTypes).pluck('id');
                    }
                }
                if ($scope.ruleTypeConfig.activeSecTypes.dlp) {
                    $scope.model.rule.minimum_hit_count = adjustDlpSensitivity($scope.model.rule.minimum_hit_count);
                    // entities for slack
                    if ($scope.model.saas === 'slack' && feature.enableSlackFeatures && feature.enableSlackSelectEntities) {
                        $scope.internal.selectedEntities = {
                            slack_file: true,
                            // default
                            slack_message: false
                        };
                        if (rule) {
                            $scope.internal.selectedEntities = $scope.model.rule.selected_entities;
                        }
                        $scope.slackEntitiesForDLP = [
                            {
                                name: 'slack_file',
                                label: 'Slack Files'
                            },
                            {
                                name: 'slack_message',
                                label: 'Slack Messages'
                            }
                        ];
                    }
                }
                if (!$scope.model.rule.static_phishing) {
                    $scope.model.rule.static_phishing = { static_rules: [] };
                }
                $scope.model.security_events = rule ? rule.security_events : {};
                if (!$scope.model.security_events || !_($scope.severityTypes).find(function (item) {
                        return item.id === $scope.model.security_events.severity;
                    })) {
                    $scope.model.security_events.severity = defaultSeverity;
                }
                var disabledTEX = {};
                _($scope.workflows).each(function (workflow) {
                    if ((workflow.id === 'threat_extraction_types_clean' || workflow.id === 'threat_extraction_types_convert') && rule && rule.rule.workflows && rule.rule.workflows[workflow.id]) {
                        $scope.internal.workflows[workflow.id] = rule.rule.workflows[workflow.id];
                        // logic to correct unusual tex type disabled issue
                        if ($scope.internal.workflows[workflow.id].disabled) {
                            if (disabledTEX.id) {
                                if (disabledTEX.selected !== 'none') {
                                    $scope.internal.workflows[disabledTEX.id].disabled = false;
                                }
                                if ($scope.internal.workflows[workflow.id].selected !== 'none') {
                                    $scope.internal.workflows[workflow.id].disabled = false;
                                }
                                if (disabledTEX.selected === 'none' && $scope.internal.workflows[workflow.id].selected === 'none') {
                                    $scope.internal.workflows[disabledTEX.id].disabled = false;
                                    $scope.internal.workflows[workflow.id].disabled = false;
                                }
                            } else {
                                disabledTEX = angular.copy($scope.internal.workflows[workflow.id]);
                                disabledTEX.id = workflow.id;
                            }
                        }
                        return;
                    }
                    var found = rule && _(workflow.variants).find(function (variant) {
                        return variant.id === (rule.rule.workflows && rule.rule.workflows[workflow.id]);
                    });
                    if (found) {
                        $scope.internal.workflows[workflow.id] = found.id;
                        return;
                    }
                    $scope.internal.workflows[workflow.id] = _(workflow.variants).find(function (item) {
                        return item.default;
                    }).id;
                });
                if (rule && _($scope.modes).find(function (mode) {
                        return mode.id === rule.mode;
                    })) {
                    $scope.model.mode = rule.mode;
                } else {
                    $scope.model.mode = $scope.ruleTypeConfig.defaultMode;
                }
                if (!rule) {
                    setDefaultActions();
                }
                if ($scope.ruleTypeConfig.showSkipInternal && $scope.model.rule.skip_internal !== false) {
                    $scope.model.rule.skip_internal = true;
                }
                $scope.internal.selectedApps = {};
                if (!rule || $scope.noAppSelector || rule.rule && rule.rule.active_sectools && rule.rule.active_sectools.all_tools) {
                    $scope.internal.allApps = true;
                }
                if ($scope.ruleTypeConfig && $scope.ruleTypeConfig.overwrite && $scope.ruleTypeConfig.overwrite[$scope.model.saas] && $scope.ruleTypeConfig.overwrite[$scope.model.saas].availableApps) {
                    $scope.disableSelectAllApps = true;
                }
                if ($scope.internal.allApps) {
                    selectAllApps();
                    if ($scope.ruleTypeConfig && $scope.ruleTypeConfig.overwrite && $scope.ruleTypeConfig.overwrite[$scope.model.saas] && $scope.ruleTypeConfig.overwrite[$scope.model.saas].availableApps) {
                        $scope.internal.allApps = false;
                    }
                } else {
                    if (rule.rule.active_sectools && rule.rule.active_sectools.any) {
                        $scope.internal.selectedApps = _(rule.rule.active_sectools.any).chain().map(function (appName) {
                            return [
                                appName,
                                true
                            ];
                        }).object().value();
                        _($scope.activeAppsBySecType).each(function (apps, secType) {
                            if ($scope.ruleTypeConfig.activeSecTypes[secType] && _(apps).find(function (app) {
                                    return app.name === 'cp_threat_extraction';
                                })) {
                                $scope.internal.selectedApps.cp_threat_extraction = true;
                            }
                        });
                    }
                }
                if (rule) {
                    _(rule.actions).each(function (actions) {
                        _(actions).each(function (action) {
                            if (!action.id) {
                                return;
                            }
                            $scope.internal.actions[action.id] = { enabled: true };
                            if (action.input) {
                                $scope.internal.actions[action.id].params = {};
                                _(action.input).each(function (param, paramId) {
                                    $scope.internal.actions[action.id].params[paramId] = param.value;
                                });
                            }
                        });
                    });
                }
                if ($scope.ruleTypeConfig.id === 'access_control' && !_($scope.devicesTypes).find(function (type) {
                        return type.id === $scope.model.rule.devices;
                    })) {
                    $scope.model.rule.devices = 'all';
                }
                $scope.ruleModeChanged();
                if (feature.checkpointTheme && $scope.model.rule && $scope.model.rule.tool_specific_rules) {
                    var toolSpecificRules = angular.copy($scope.toolSpecificRules);
                    var cacheToolSpecificRules = [];
                    _($scope.model.rule.tool_specific_rules).each(function (value) {
                        var item, foundIndex = 0;
                        item = _(toolSpecificRules).find(function (val, k) {
                            if (val.id === value) {
                                foundIndex = k;
                                return true;
                            }
                            return false;
                        });
                        if (item) {
                            cacheToolSpecificRules.push(item);
                            toolSpecificRules.splice(foundIndex, 1);
                        }
                    });
                    $scope.toolSpecificRules = cacheToolSpecificRules.concat(toolSpecificRules);
                }
                if ($scope.model.isManualMailflow) {
                    var linkForManualMode = path('common').staticFile('AvananO365-ManualCreationOfMailConfigs.pdf');
                    if (feature.checkpointTheme) {
                        linkForManualMode.path = 'https://sc1.checkpoint.com/documents/CloudGuard_SaaS_ManualConfiguration/html_frameset.htm';
                    } else if (feature.sonicwallTheme) {
                        linkForManualMode = path('common').staticFile('CAS_SaaS_Manually_Configuring_Office365.pdf');
                    }
                    var textManualMailFlow = 'Note that you are in manual mode and some policy ' + 'changes may require to change some Office 365 configuration. The following ' + '<a class="manual-mailflow-doc" target="_blank" href="' + linkForManualMode.path + '"><strong>Link</strong></a>' + ' describes those changes';
                    return modals.alert(textManualMailFlow, {
                        title: 'Warning',
                        display: 'html'
                    });
                }
                $scope.TipConfigExcludedIps = {
                    content: { text: 'In order to enter protect (inline) mode, mail flow rules are created in Office 365.<br />' + 'The default behaviour adds all inbound connector IPs to the list of excluded IPs.<br />' + 'By selecting this check box, you will need to configure the list of excluded IPs manually.<br />' + 'Without adding the service IPs to the list of excluded IPs - emails will be read in monitor mode.' },
                    position: {
                        at: 'top center',
                        my: 'bottom center'
                    },
                    style: { classes: 'qtip-standard beta-tooltip' }
                };
                if ($scope.model.saas === 'google_drive' && $scope.ruleTypeConfig.id === 'av') {
                    $scope.scopeDetail = 'The malware policy only applies on internal sharing.';
                }
                if (feature.enableIgnoreLowConfidenceResults && $scope.ruleTypeConfig.id === 'av' && policyRuleConfig.getSaasType($scope.model.saas) === 'drive') {
                    $scope.enableIgnoreLowConfidenceResults = true;
                    $scope.internal.ignoreLowConfidenceResults = rule ? $scope.model.rule.ignore_low_confidence_results : true;
                }
                if (feature.protectOutgoingEmails && $scope.ruleTypeConfig.id === 'av' && $scope.ruleTypeConfig.id === 'av_ap' && rule.mode === 'inline' && policyRuleConfig.getSaasType($scope.model.saas) === 'email') {
                    $scope.enableProtectOutgoingEmails = true;
                }
            });
        }
        if ($route.current.mode === 'create') {
            $scope.mode = 'create';
            $scope.step = 'create';
            $scope.pageTitlePrefix = 'New Policy Rule';
            loadApps().then(function () {
                $scope.loading = false;
                var locationSaaS = $location.search().saas;
                $scope.internal.saasSelectorOpen = true;
                if (locationSaaS) {
                    var saasApp = _(saasApps).find(function (app) {
                        return app.name === locationSaaS && app.state === 'active';
                    });
                    if (saasApp) {
                        $scope.model.saas = saasApp.name;
                        $scope.internal.saasSelectorOpen = false;
                        $timeout(function () {
                            $scope.internal.ruleTypeSelectorOpen = true;
                        });
                    }
                }
            });
        } else {
            $scope.mode = 'edit';
            $scope.pageTitlePrefix = 'Edit Rule';
            $scope.pageTitle = $scope.pageTitlePrefix;
            if (!$routeParams.id) {
                errorStatusHolder.errorStatus(404);
                return;
            }
            $scope.ruleId = $routeParams.id;
            $q.all([
                policyRulesDao.retrieve($scope.ruleId),
                loadApps()
            ]).then(function (responses) {
                return initializeDetailsView(responses[0].data);
            }, function (error) {
                errorStatusHolder.errorStatus(error.status);
            });
        }
        $scope.pageTitle = $scope.pageTitlePrefix;
        $scope.$watch('model.saas', function (newValue, oldValue) {
            if (newValue && newValue !== 'office365_emails' && newValue !== 'google_mail' && $scope.activeAppsBySecType.av) {
                var pos = _($scope.activeAppsBySecType.av).findIndex(function (app) {
                    return app.name === 'cp_threat_extraction';
                });
                if (pos !== -1) {
                    $scope.activeAppsBySecType.av.splice(pos, 1);
                }
            }
            if ($scope.step !== 'create') {
                return;
            }
            if (!$scope.model.saas) {
                $scope.ruleTypes = [];
            } else {
                $scope.ruleTypes = policyRuleConfig.getSaasRuleTypes($scope.model.saas, securityApps);
            }
            if (oldValue !== newValue || !newValue) {
                $scope.model.ruleType = null;
            }
        });
        $scope.$watch('internal.saasSelectorOpen', function (newValue, oldValue) {
            if (newValue === false && oldValue === true && $scope.model.saas && !$scope.model.ruleType && $scope.ruleTypes.length) {
                $scope.internal.ruleTypeSelectorOpen = true;
            }
        });
        $scope.nextDisabled = function () {
            return !$scope.model.saas || !$scope.model.ruleType;
        };
        $scope.back = function () {
            $scope.step = 'create';
        };
        $scope.next = function () {
            if ($scope.nextDisabled()) {
                return;
            }
            $scope.loading = true;
            return initializeDetailsView(null);
        };
        $scope.scopes = {
            available: {
                getItems: function (offset, limit, filter, timeoutPromise) {
                    var grouped = {};
                    _($scope.model.scopes).each(function (item) {
                        grouped[item.type] = grouped[item.type] || [];
                        grouped[item.type].push(item);
                    });
                    _($scope.model.excludes).each(function (item) {
                        grouped[item.type] = grouped[item.type] || [];
                        grouped[item.type].push(item);
                    });
                    var params = {};
                    _(grouped).each(function (items, key) {
                        params['exclude_' + key + '_ids'] = _(items).pluck('entity_id');
                    });
                    return loadPolicyScopes($scope.model.saas, params).filter(filter).timeout(timeoutPromise).pagination(offset, limit).then(function (res) {
                        if (res.data && res.data.rows) {
                            _(res.data.rows).each(function (row) {
                                if ($scope.model.licenses && !row.av_license_enabled) {
                                    row.redirect = routeHelper.getHref('license-configuration', { module: $scope.model.saas });
                                }
                            });
                        }
                        return $q.when(res);
                    });
                },
                doubleClicked: function () {
                    $scope.scopesAdd();
                },
                formatItem: formatIdentity,
                uniqueId: policyRuleConfig.identityUniqueId
            },
            selected: {
                getItems: function (offset, limit, filter) {
                    var filterBy = filter && filter.trim().toLowerCase();
                    return $q.when({
                        data: {
                            rows: $scope.model.scopes && $scope.model.scopes.length && _($scope.model.scopes).chain().filter(function (scope) {
                                if (filterBy) {
                                    return scope && scope.gui_label && scope.gui_label.toLowerCase().indexOf(filterBy) !== -1;
                                }
                                return true;
                            }).rest(offset).first(limit).map(function (item) {
                                return item;
                            }).value() || []
                        }
                    });
                },
                doubleClicked: function () {
                    $scope.scopesRemove();
                },
                formatItem: formatIdentity,
                uniqueId: policyRuleConfig.identityUniqueId
            },
            excluded: {
                getItems: function (offset, limit, filter) {
                    var filterBy = filter && filter.trim().toLowerCase();
                    return $q.when({
                        data: {
                            rows: $scope.model.excludes && $scope.model.excludes.length && _($scope.model.excludes).chain().filter(function (scope) {
                                if (filterBy) {
                                    return scope && scope.gui_label && scope.gui_label.toLowerCase().indexOf(filterBy) !== -1;
                                }
                                return true;
                            }).rest(offset).first(limit).map(function (item) {
                                return item;
                            }).value() || []
                        }
                    });
                },
                doubleClicked: function () {
                    $scope.excludesRemove();
                },
                formatItem: formatIdentity,
                uniqueId: policyRuleConfig.identityUniqueId
            }
        };
        var reloadIdentities = function (exclude) {
            if (exclude !== 'available') {
                $scope.scopes.available.reload();
            }
            if (exclude !== 'selected' && $scope.scopes.selected.reload) {
                $scope.scopes.selected.reload();
            }
            if (exclude !== 'excluded' && $scope.scopes.excluded.reload) {
                $scope.scopes.excluded.reload();
            }
        };
        var removeIdentites = function (type) {
            var t = 'scopes';
            if (type === 'excluded') {
                t = 'excludes';
            }
            var items = $scope.scopes[type].getSelected();
            if (items.length) {
                var itemsMap = _(items).reduce(function (memo, item) {
                    memo[item.type] = memo[item.type] || {};
                    memo[item.type][item.entity_id] = true;
                    return memo;
                }, {});
                $scope.model[t] = _($scope.model[t]).chain().filter(function (item) {
                    return !itemsMap[item.type] || !itemsMap[item.type][item.entity_id];
                }).sortBy('order').value();
                if (type === 'excluded') {
                    reloadIdentities('selected');
                } else if (type === 'selected') {
                    reloadIdentities('excluded');
                }
            }
        };
        var addToSelectedScopes = function (items, from, noReload) {
            $scope.model.scopes = $scope.model.scopes || [];
            if (_(items).find(function (item) {
                    return item.is_quarantine_user;
                })) {
                $scope.scopes[from].clearSelection();
                return modals.alert([
                    'Dear user,',
                    'Quarantine user should be a dedicated service user,',
                    'enforcing policy in the quarantine user is currently not supported.'
                ], {
                    title: 'Warning',
                    windowClass: 'inline-user-limit-dialog'
                });
            }
            if (sideMenuManager.limitedLicense() && _(items).find(function (item) {
                    return item.type !== 'users';
                }) && displayLimitedLicensePopupFor.includes($scope.model.saas)) {
                if (!didDisplayLimitedLicensePopup) {
                    didDisplayLimitedLicensePopup = true;
                    modals.confirm({
                        message: 'You\'re running on a limited license. Unlicensed users will ' + '<strong>not</strong> be protected. Please go to ' + '<a class="manual-mailflow-doc" href="' + $scope.model.redirectToLicenseConfig + '"><strong>license configuration screen</strong></a>' + ' to reassign licenses to users.',
                        title: 'Unlimited license',
                        windowClass: 'inline-user-limit-dialog'
                    });
                }
            }
            if ($scope.model.mode === 'inline' && !_($scope.maxInlineUsers).isNull()) {
                if (_(items).find(function (item) {
                        return item.type !== 'users';
                    })) {
                    $scope.scopes[from].clearSelection();
                    return modals.alert([
                        'Dear user,',
                        'Only users can be selected in trial version,',
                        'please upgrade to allow inline protection for groups'
                    ], {
                        title: 'Trial version',
                        windowClass: 'inline-user-limit-dialog'
                    });
                }
                if (items.length + $scope.model.scopes.length > $scope.maxInlineUsers) {
                    $scope.scopes[from].clearSelection();
                    return modals.alert([
                        'Dear user,',
                        'You\'re running a trial version.',
                        'Trial version allows protection of ' + $scope.maxInlineUsers + ' users or less.'
                    ], {
                        title: 'Trial version',
                        windowClass: 'inline-user-limit-dialog'
                    });
                }
            }
            _(items).each(function (item) {
                if (_($scope.model.scopes).findIndex(function (scope) {
                        return scope.entity_id === item.entity_id;
                    }) === -1) {
                    $scope.model.scopes.push(item);
                }
            });
            $scope.model.scopes = _($scope.model.scopes).sortBy('order');
            if (from === 'excluded') {
                $scope.model.excludes = _($scope.model.excludes).reject(function (scope) {
                    return _(items).findIndex(function (item) {
                        return scope.entity_id === item.entity_id;
                    }) !== -1;
                });
            }
            if (!noReload) {
                if (from === 'available') {
                    reloadIdentities('excluded');
                } else if (from === 'excluded') {
                    reloadIdentities('available');
                }
            }
        };
        $scope.scopesAdd = function () {
            var items1 = $scope.scopes.available.getSelected();
            var items2 = $scope.scopes.excluded.getSelected();
            if (items1.length && items2.length) {
                addToSelectedScopes(items1, 'available', true);
                addToSelectedScopes(items2, 'excluded', true);
                reloadIdentities();
            } else if (items1.length) {
                addToSelectedScopes(items1, 'available');
            } else if (items2.length) {
                addToSelectedScopes(items2, 'excluded');
            }
        };
        var addToExcludedScopes = function (items, from, noReload) {
            $scope.model.excludes = $scope.model.excludes || [];
            _(items).each(function (item) {
                $scope.model.excludes.push(item);
            });
            $scope.model.excludes = _($scope.model.excludes).sortBy('order');
            if (from === 'selected') {
                $scope.model.scopes = _($scope.model.scopes).reject(function (scope) {
                    return _(items).findIndex(function (item) {
                        return scope.entity_id === item.entity_id;
                    }) !== -1;
                });
            }
            if (!noReload) {
                if (from === 'available') {
                    reloadIdentities('selected');
                } else if (from === 'selected') {
                    reloadIdentities('available');
                }
            }
        };
        $scope.excludesAdd = function () {
            var items1 = $scope.scopes.available.getSelected();
            var items2 = $scope.scopes.selected.getSelected ? $scope.scopes.selected.getSelected() : [];
            if (items1.length && items2.length) {
                addToExcludedScopes(items1, 'available', true);
                addToExcludedScopes(items2, 'selected', true);
                reloadIdentities();
            } else if (items1.length) {
                addToExcludedScopes(items1, 'available');
            } else if (items2.length) {
                addToExcludedScopes(items2, 'selected');
            }
        };
        $scope.scopesRemove = function () {
            removeIdentites('selected');
        };
        $scope.excludesRemove = function () {
            removeIdentites('excluded');
        };
        $scope.scopesRemoveAll = function () {
            $scope.model.scopes = [];
            reloadIdentities('excluded');
        };
        $scope.excludesRemoveAll = function () {
            $scope.model.excludes = [];
            reloadIdentities('selected');
        };
        $scope.allScopesSelectorTip = function () {
            if ($scope.model.mode !== 'inline' || _($scope.maxInlineUsers).isNull()) {
                return;
            }
            return {
                content: 'This feature is disabled in trial version,<br /> please upgrade to allow inline protection for an entire account',
                position: {
                    my: 'bottom left',
                    at: 'top center'
                }
            };
        };
        $scope.allScopesDisabled = function () {
            return !$scope.scopesAvailable || $scope.model.mode === 'inline' && !_($scope.maxInlineUsers).isNull();
        };
        $scope.ruleModeChanged = function (newValue, oldValue) {
            if ($scope.model.mode === 'inline' && !_($scope.maxInlineUsers).isNull() && $scope.model.all) {
                $scope.model.all = false;
            }
            verifySelectedScopes();
            $scope.showWorkflows = _($scope.workflows).findIndex(function (workflow) {
                return $scope.workflowAvailable(workflow);
            }) !== -1;
        };
        function verifySelectedScopes(onSave) {
            if ($scope.model.mode !== 'inline' || _($scope.maxInlineUsers).isNull()) {
                return true;
            }
            if (onSave && !$scope.model.all && (!$scope.model.scopes || !$scope.model.scopes.length)) {
                modals.alert('Please select at least one user to protect', {
                    title: 'Error',
                    windowClass: 'inline-user-limit-dialog'
                });
                return false;
            }
            if ($scope.model.all || $scope.model.scopes && $scope.model.scopes.length > $scope.maxInlineUsers || _($scope.model.scopes).find(function (item) {
                    return item.type !== 'users';
                })) {
                modals.alert([
                    'Dear user,',
                    'You\'re running a trial version.',
                    'Trial version allows protection of ' + $scope.maxInlineUsers + ' users or less.',
                    'Please change your protection scopes selection.'
                ], {
                    title: 'Trial version',
                    windowClass: 'inline-user-limit-dialog'
                });
                return false;
            }
            return true;
        }
        function checkScopes(saas, rule) {
            $scope.scopesAvailable = false;
            return $q.allSettled([
                loadPolicyScopes(saas).pagination(0, 1),
                licensesDao.getLicenses()
            ]).then(function (responses) {
                if (rule) {
                    $scope.model.all = true;
                }
                if (responses[0].value.data && responses[0].value.data.rows && responses[0].value.data.rows.length) {
                    $scope.scopesAvailable = true;
                    if (rule) {
                        var list = policyRuleConfig.identitiesToList(rule);
                        if (list) {
                            if (list.scopes && list.scopes.length) {
                                $scope.model.scopes = list.scopes;
                                $scope.model.all = false;
                            }
                            if (list.excludes && list.excludes.length) {
                                $scope.model.excludes = list.excludes;
                            }
                        }
                    }
                } else {
                    $scope.scopesAvailable = false;
                }
                if (displayLimitedLicensePopupFor.includes($scope.model.saas) && responses[1].value.data && responses[1].value.data.data && responses[1].value.data.data.length) {
                    var foundData = _(responses[1].value.data.data).find(function (data) {
                        return data.saas === $scope.model.saas;
                    });
                    if (foundData) {
                        $scope.model.licenses = !!foundData.seats;
                        $scope.model.redirectToLicenseConfig = routeHelper.getHref('license-configuration', { module: $scope.model.saas });
                        $scope.configureLicensedTip = 'Click to configure licensed users';
                        if ($scope.model.licenses) {
                            $scope.model.disableOnClickItem.push('av_license_enabled');
                        }
                    }
                }
                $scope.loadingScopes = false;
            }, function (error) {
                if (rule) {
                    $scope.scopesAvailable = false;
                    $scope.model.all = true;
                } else {
                    $scope.scopesAvailable = true;
                    $scope.model.all = false;
                }
                $scope.loadingScopes = false;
                return $q.when();
            }).then(_.noop, _.noop);
        }
        function formatIdentity(item) {
            return policyRuleConfig.formatIdentity(item);
        }
        function saveRule(rule) {
            if ($scope.mode === 'create') {
                return policyRulesDao.create(rule);
            } else {
                return policyRulesDao.update($scope.ruleId, rule);
            }
        }
        function savedPolicy(params) {
            if (params && params.foundEncryptionWorkflow) {
                modals.alert('The system is now configuring the mail-flow rule in Office 365, once configuration is completed emails will be encrypted according to the policy settings.', {
                    title: 'Office 365 Encryption status',
                    closeText: 'Ok',
                    notCloseOnRouteChange: true
                });
            }
            routeHelper.redirectTo('policy-rules');
        }
        function processRejection(err, found412Error, rule, foundEncryptionWorkflow) {
            if ($scope.model.saas === 'office365_emails' && $scope.model.mode === 'inline' && err.status === 412) {
                return modals.confirm({
                    title: 'Warning',
                    okText: 'Continue',
                    cancelText: 'Cancel',
                    message: 'Dear user,<br />' + 'The policy has one or more Office 365 email rules ' + 'in inline mode with scope that includes both groups and users. ' + 'This may cause a performance problem in Office 365.<br />' + 'Therefore, it is recommended that all inline modes ' + 'scopes includes either groups-only or users-only.'
                }).then(function () {
                    $scope.loading = true;
                    rule.ignore_mixed_warning = 1;
                    return saveRule(rule);
                }).then(function () {
                    savedPolicy({ foundEncryptionWorkflow: foundEncryptionWorkflow });
                });
            } else if (feature.enableOneClickEncryption && err.status === 423 && err.data && err.data.error_type === 'O365_PROTECT_POLICY_SERVICE_USER_VERIFICATION_ERROR' && $scope.model.saas === 'office365_emails' && $scope.model.ruleType === 'dlp') {
                return encryptionService.retryCreateEncryptionRule(err.data.message).then(function () {
                    return saveRule(rule);
                }, function (err1) {
                    $scope.loading = false;
                    console.log('Failed on retryCreateEncryptionRule():', err1);
                });
            } else if (err.status === 422 && err.data) {
                $scope.loading = false;
                return modals.alert(err.data.message || 'Policy rule cannot be saved.', { title: err.data.title || 'Error' });
            } else {
                $scope.loading = false;
            }
        }
        function checkRuleErrors(rule) {
            // if tex is enabled checks that tex_convert and tex_clean are not both 'none'
            var tex_mode = rule.rule && rule.rule.workflows && rule.rule.workflows.threat_extraction_mode;
            if (tex_mode) {
                var tex_convert = rule.rule && rule.rule.workflows && rule.rule.workflows.threat_extraction_types_convert && rule.rule.workflows.threat_extraction_types_convert.selected;
                var tex_clean = rule.rule && rule.rule.workflows && rule.rule.workflows.threat_extraction_types_clean && rule.rule.workflows.threat_extraction_types_clean.selected;
                if (tex_clean == 'none' && tex_convert == 'none') {
                    return 'Threat Extraction: Clean and Convert can not be both \'none\'';
                }
            }
            return '';
        }
        $scope.workflowAvailable = function (workflow) {
            return $scope.ruleTypeConfig.workflows && policyRuleModes.get($scope.model.mode).workflow && secTypeSelected(workflow.secType, workflow);
        };
        function secTypeSelected(secType, workflow) {
            if ($scope.ruleTypeConfig.alwaysOnSecTypes && $scope.ruleTypeConfig.alwaysOnSecTypes[secType]) {
                return true;
            }
            if (!$scope.ruleTypeConfig.activeSecTypes[secType]) {
                return false;
            }
            if (workflow && workflow.moduleName === 'cp_threat_extraction') {
                if (workflow.id === 'threat_extraction_workflow') {
                    var avIsOn = false;
                    if (_($scope.activeAppsBySecType.av).isArray()) {
                        avIsOn = _($scope.activeAppsBySecType.av).findIndex(function (app) {
                            return app.name !== 'cp_threat_extraction' && $scope.internal.selectedApps[app.name] === true;
                        }) !== -1;
                    }
                    _(workflow.variants).each(function (variant) {
                        if (variant.id !== 'admin_approve') {
                            if (avIsOn) {
                                variant.disabled = false;
                                variant.tooltip = null;
                            } else {
                                variant.disabled = true;
                                variant.tooltip = {
                                    content: { text: 'At least one anti-malware tool...' },
                                    position: {
                                        my: 'bottom center',
                                        at: 'top center'
                                    },
                                    style: { classes: 'qtip-standard' }
                                };
                            }
                        }
                    });
                }
                if (workflow.id !== 'threat_extraction_mode' && workflow.id !== 'threat_extraction_workflow' && !_($scope.internal.workflows[workflow.id]).isObject()) {
                    $scope.internal.workflows[workflow.id] = {
                        selected: _.clone($scope.internal.workflows[workflow.id]),
                        values: [],
                        disabled: false
                    };
                }
                if ($scope.model.mode !== 'inline') {
                    return false;
                }
                return !!$scope.internal.selectedApps.cp_threat_extraction;
            }
            return !!_($scope.activeAppsBySecType[secType]).find(function (app) {
                return app.name !== 'cp_threat_extraction' && $scope.internal.selectedApps[app.name];
            });
        }
        function otherActionConditions(action) {
            if (action && (action.id === 'send_email_to_admin_email_dlp_regex_no_match' || action.id === 'send_email_to_admin_email_dlp_regex_match')) {
                var enableDlpRegexActions = false;
                _($scope.internal.workflows).each(function (workflow) {
                    if ($scope.model.ruleType === 'dlp' && workflow.indexOf('_encryption') !== -1) {
                        enableDlpRegexActions = true;
                    }
                });
                return enableDlpRegexActions && $scope.model.useRegex && $scope.model.rule.subject_regex;
            }
            return true;
        }
        function texSelectorTip(text) {
            return {
                content: { text: text },
                position: {
                    at: 'bottom center',
                    my: 'top left'
                },
                style: {
                    classes: 'qtip-standard',
                    tip: {
                        width: 14,
                        height: 8,
                        corner: true
                    }
                }
            };
        }
        $scope.changeTexTypes = function (newValue, oldValue, workflowId) {
            if (newValue !== oldValue) {
                delete $scope.internal.workflows[workflowId][oldValue];
                delete $scope.internal.workflows.threat_extraction_types_convert.tooltip;
                delete $scope.internal.workflows.threat_extraction_types_clean.tooltip;
                $scope.internal.workflows[workflowId][newValue] = true;
                if (newValue === 'all') {
                    $scope.internal.workflows.threat_extraction_types_clean.values = [];
                    $scope.internal.workflows.threat_extraction_types_convert.values = [];
                    if (workflowId === 'threat_extraction_types_clean') {
                        $scope.internal.workflows.threat_extraction_types_convert = {
                            selected: 'none',
                            values: [],
                            disabled: true,
                            tooltip: texSelectorTip('Please disable all file types to allow selecting Convert mode.')
                        };
                    } else {
                        $scope.internal.workflows.threat_extraction_types_clean = {
                            selected: 'none',
                            values: [],
                            disabled: true,
                            tooltip: texSelectorTip('Please disable all file types to allow selecting Clean mode.')
                        };
                    }
                } else {
                    if (newValue !== 'none' && (workflowId === 'threat_extraction_types_clean' && newValue === $scope.internal.workflows.threat_extraction_types_convert.selected || workflowId === 'threat_extraction_types_convert' && newValue === $scope.internal.workflows.threat_extraction_types_clean.selected)) {
                        $scope.internal.workflows.threat_extraction_types_convert.disabled = false;
                        $scope.internal.workflows.threat_extraction_types_convert.tooltip = texSelectorTip('In case of overlapping file types - clean always has the higher priority.');
                        $scope.internal.workflows.threat_extraction_types_clean.disabled = false;
                    } else {
                        if (workflowId === 'threat_extraction_types_clean') {
                            $scope.internal.workflows.threat_extraction_types_convert.disabled = false;
                            delete $scope.internal.workflows.threat_extraction_types_convert.tooltip;
                        } else {
                            $scope.internal.workflows.threat_extraction_types_clean.disabled = false;
                            delete $scope.internal.workflows.threat_extraction_types_clean.tooltip;
                        }
                    }
                }
            }
        };
        $scope.$watch('internal.workflows.threat_extraction_mode', function (newVal, oldVal) {
            if (newVal) {
                _($scope.workflows).map(function (workflow) {
                    if (workflow.secType === 'av' && !workflow.moduleName) {
                        workflow.tooltip = {
                            content: { text: 'Takes place for unsupported file types.' },
                            position: {
                                my: 'bottom center',
                                at: 'top center'
                            },
                            style: { classes: 'qtip-standard' }
                        };
                    }
                });
            } else if (oldVal && !newVal) {
                _($scope.workflows).map(function (workflow) {
                    if (workflow.secType === 'av' && !workflow.moduleName) {
                        workflow.tooltip = null;
                    }
                });
            }
        });
        $scope.actionAvailable = function (action) {
            return action.rule_mode && _(action.rule_mode).contains($scope.model.mode) && !!_(action.security_types).find(function (secType) {
                return secTypeSelected(secType);
            }) && otherActionConditions(action);
        };
        $scope.actionsAvailable = function () {
            return !!_($scope.actions).find(function (action) {
                return $scope.actionAvailable(action);
            });
        };
        function isRegexValid(regex) {
            try {
                var regex1 = RegExp(regex);
                return true;
            } catch (error) {
                return false;
            }
        }
        function selectAllApps() {
            _($scope.activeAppsBySecType).each(function (apps, secType) {
                if ($scope.ruleTypeConfig.activeSecTypes[secType]) {
                    _(apps).each(function (app) {
                        $scope.internal.selectedApps[app.name] = true;
                    });
                }
            });
        }
        function setDefaultActions() {
            _($scope.actions).each(function (action) {
                if (!action.id || !$scope.actionAvailable(action)) {
                    return;
                }
                if (!$scope.internal.actions[action.id]) {
                    $scope.internal.actions[action.id] = {};
                }
                if (action.rule_mode_default && _(action.rule_mode_default).contains($scope.model.mode)) {
                    $scope.internal.actions[action.id].enabled = true;
                } else {
                    $scope.internal.actions[action.id].enabled = false;
                }
            });
        }
        $scope.$watch('model.mode', function (newValue, oldValue) {
            if (newValue === 'inline') {
                $scope.savingConfigTip = {
                    content: { text: '<strong>Note: </strong>It takes up to 10 minutes for the policy configuration to take effect.' },
                    position: {
                        at: 'top center',
                        my: 'bottom right'
                    },
                    style: { classes: 'qtip-standard' }
                };
            } else {
                $scope.savingConfigTip = undefined;
                $scope.model.useRegex = false;
            }
            if (oldValue && newValue !== oldValue) {
                setDefaultActions();
                if ($scope.saasConfig) {
                    generateWorkflows($scope.saasConfig, newValue);
                }
            }
        });
        $scope.$watch('internal.allApps', function () {
            if ($scope.internal.allApps) {
                selectAllApps();
            }
        });
        $scope.isActionConfigurable = function (action) {
            return action.data.name === 'send_mail';
        };
        $scope.showActionSettings = function (action) {
            var modalPromise = null;
            function genActionModal(action, actionData) {
                var templateData = {};
                if (actionData && actionData.attributes) {
                    templateData = actionData;
                } else {
                    templateData = action.data;
                }
                modalPromise = modals.params([{
                        lastPage: true,
                        params: [
                            {
                                id: 'subject',
                                type: 'property-string',
                                label: 'Subject',
                                validation: { required: true },
                                data: templateData.attributes.subject,
                                propertiesHideFilter: true,
                                propertiesHideAdvancedFilter: true
                            },
                            {
                                id: 'content',
                                type: 'property-email-body',
                                label: 'Body',
                                validation: { required: true },
                                data: templateData.attributes.content,
                                propertiesHideFilter: true,
                                propertiesHideAdvancedFilter: true
                            }
                        ],
                        getProperties: function () {
                            var result = {
                                '0': {
                                    id: '',
                                    sub: _(action.tags_list).map(function (tag) {
                                        return tag.id;
                                    })
                                }
                            };
                            _(action.tags_list).each(function (tag) {
                                result[tag.id] = {
                                    id: tag.id,
                                    label: tag.label,
                                    selectable: true
                                };
                            });
                            return result;
                        }
                    }], 'Customize email content', 'lg');
                modalPromise.then(function (result) {
                    // this is for edit page
                    if ($scope.ruleId) {
                        var updatedTemplate = {};
                        updatedTemplate[action.id] = { attributes: result };
                        policyRulesDao.updateActionTypePerRule($scope.ruleId, updatedTemplate);
                    } else {
                        // This is for new page
                        policyRulesDao.updateActionType(action.id, {
                            data: { attributes: result },
                            module: $scope.model.saas
                        }).then(function () {
                            $.extend(action.data.attributes, result);
                        });
                    }
                });
            }
            policyRulesDao.retrieveAlertTemplate($scope.ruleId, action.id).then(function (response) {
                genActionModal(action, response.data);
            }).catch(function () {
                genActionModal(action, {});
            });
        };
        $scope.showWorkflowSettings = function (configParams) {
            return appConfigurator.configureApp($scope.model.saas, configParams.params);
        };
        $scope.configureAlertReceivers = function () {
            alertReceiversModal.show();
        };
        $scope.labelForConfigAntiPhishing = 'Configure Anti-Impersonation and Phishing Confidence-Level';
        if (feature.checkpointTheme) {
            $scope.labelForConfigAntiPhishing = 'Anti-phishing settings';
        }
        $scope.configureAntiPhishing = function () {
            var apModule = _(securityApps).find(function (app) {
                return app.name === 'ap_avanan';
            });
            var convertedApModule = modulePropsToOptions(apModule, { licenseButton: {} }, true);
            return appConfigurator.configure(convertedApModule, undefined, undefined, undefined, true);
        };
        $scope.clearDlpSecTools = function () {
            $('input[name=dlp-security-tools]').prop('checked', false);
            $scope.internal.dlpSecTool = '';
        };
        $scope.save = function () {
            if (!verifySelectedScopes(true) || $scope.savingConfig) {
                return;
            }
            var selectedSecTypes = _($scope.ruleTypeConfig.sec_types).filter(function (secType) {
                return secTypeSelected(secType);
            });
            var missingConfig = false;
            var isUsers = false, isGroups = false;
            var p = $q.when();
            var rule = {
                'name': $scope.model.name,
                'state': $scope.model.state,
                'saas': $scope.model.saas,
                'type': policyRuleConfig.backendRuleType($scope.model.ruleType),
                'mode': $scope.model.mode,
                'security_events': $scope.model.security_events,
                'rule': {},
                'actions': _($scope.actions).chain().filter(function (action) {
                    return $scope.actionAvailable(action) && $scope.internal.actions[action.id] && $scope.internal.actions[action.id].enabled;
                }).reduce(function (memo, actionInfo) {
                    if (!missingConfig && actionInfo.missing_configs) {
                        missingConfig = {
                            label: actionInfo.label,
                            missing_configs: actionInfo.missing_configs,
                            error_message: actionInfo.error_message || 'You selected  to run <strong>' + actionInfo.label + '</strong> for events generated by this rule.<br />' + 'Configuration parameters required to run this actions are not set correctly.'
                        };
                    }
                    var action = { id: actionInfo.id };
                    action.attributes = _(actionInfo.data.attributes).clone() || {};
                    if (actionInfo.input) {
                        action.input = {};
                        _(actionInfo.input).each(function (param, paramId) {
                            action.input[paramId] = { value: $scope.internal.actions[action.id].params && $scope.internal.actions[action.id].params[paramId] || '' };
                            _(action.attributes).each(function (attribute, attributeId) {
                                if (_(attribute).isString()) {
                                    action.attributes[attributeId] = attribute.replace(new RegExp('\\{' + paramId + '\\}', 'g'), action.input[paramId].value);
                                }
                            });
                        });
                    }
                    _(action.attributes).each(function (attribute, attributeId) {
                        if (attribute == actionInfo.data.attributes[attributeId]) {
                            delete action.attributes[attributeId];
                        }
                    });
                    if (!actionInfo.security_types || !actionInfo.security_types.length || !_($scope.ruleTypeConfig.sec_types).difference(actionInfo.security_types).length) {
                        memo.all.push(action);
                    } else {
                        memo[_(actionInfo.security_types).intersection(selectedSecTypes)[0]].push(action);
                    }
                    return memo;
                }, $.extend(_($scope.ruleTypeConfig.sec_types).chain().map(function (secType) {
                    return [
                        secType,
                        []
                    ];
                }).object().value(), { all: [] })).value(),
                'tags': []
            };
            if (missingConfig) {
                return modals.confirm({
                    title: 'Invalid configuration',
                    message: missingConfig.error_message,
                    okText: 'Configure',
                    cancelText: 'Cancel'
                }).then(function () {
                    return appConfigurator.configureApp($scope.model.saas);
                }).then(function (configResponse) {
                    return onConfigChanged(configResponse);
                }).then(function () {
                    $scope.savingConfig = false;
                    $scope.savingConfigTip = {};
                    return $scope.save();
                });
            }
            var generateIdentity = function (memo, item) {
                if (item.type === 'users') {
                    isUsers = true;
                } else if (item.type === 'groups') {
                    isGroups = true;
                }
                memo[item.type] = memo[item.type] || {
                    type: item.entity_type,
                    items: []
                };
                memo[item.type].items.push(item.entity_id);
                return memo;
            };
            if ($scope.model.all) {
                rule.identity = {};
            } else {
                rule.identity = _($scope.model.scopes).reduce(function (memo, item) {
                    return generateIdentity(memo, item);
                }, {});
            }
            if ($scope.model.excludes && $scope.model.excludes.length) {
                var identityExcludes = _($scope.model.excludes).reduce(function (memo, item) {
                    return generateIdentity(memo, item);
                }, {});
                if (!_(identityExcludes).isEmpty()) {
                    rule.identity.exclude = identityExcludes;
                }
            }
            if (_($scope.ruleTypeConfig.activeSecTypes).find(function (enabled, secType) {
                    return enabled && (!$scope.ruleTypeConfig.alwaysOnSecTypes || !$scope.ruleTypeConfig.alwaysOnSecTypes[secType]);
                })) {
                if ($scope.internal.allApps || $scope.noAppSelector) {
                    rule.rule.active_sectools = { all_tools: true };
                } else {
                    var selectedApps = [];
                    _($scope.activeAppsBySecType).each(function (apps, secType) {
                        if ($scope.ruleTypeConfig.activeSecTypes[secType]) {
                            _(apps).each(function (app) {
                                if ($scope.internal.selectedApps[app.name] && (app.name !== 'cp_threat_extraction' || app.name === 'cp_threat_extraction' && $scope.model.mode === 'inline' && $scope.internal.workflows.threat_extraction_mode)) {
                                    selectedApps.push(app.name);
                                }
                            });
                        }
                    });
                    if (selectedApps.length) {
                        rule.rule.active_sectools = { any: selectedApps };
                    } else {
                        modals.alert('Please select at least one security tool', { title: 'Error' });
                        return;
                    }
                }
            }
            if ($scope.ruleTypeConfig.activeSecTypes.dlp) {
                if ($scope.internal.dlpSecTool) {
                    rule.rule.active_sectools = { any: [$scope.internal.dlpSecTool] };
                }
                if ($scope.internal.dlpSecTool === 'dlp_checkpoint2') {
                    rule.rule.dlp_rules = ['sectool_managed'];
                } else {
                    if (feature.checkpointTheme) {
                        if (!$scope.model.rule.tool_specific_rules || !$scope.model.rule.tool_specific_rules.length) {
                            modals.alert('Please select at least one DLP rule', { title: 'Error' });
                            return;
                        }
                        rule.rule.tool_specific_rules = $scope.model.rule.tool_specific_rules;
                    } else {
                        if ($scope.model.useRegex && $scope.model.mode === 'inline') {
                            if (!$scope.model.rule.subject_regex && (!$scope.model.rule.dlp_rules || !$scope.model.rule.dlp_rules.length)) {
                                modals.alert('Please fill out DLP subject regular expression or select at least one DLP rule', { title: 'Error' });
                                return;
                            }
                            if ($scope.model.rule.subject_regex) {
                                rule.rule.subject_regex = $scope.model.rule.subject_regex;
                            }
                            if ($scope.model.rule.dlp_rules && $scope.model.rule.dlp_rules.length) {
                                rule.rule.dlp_rules = $scope.model.rule.dlp_rules;
                            }
                        } else {
                            if (!$scope.model.rule.dlp_rules || !$scope.model.rule.dlp_rules.length) {
                                modals.alert('Please select at least one DLP rule', { title: 'Error' });
                                return;
                            }
                            rule.rule.dlp_rules = $scope.model.rule.dlp_rules;
                        }
                    }
                    rule.rule.minimum_hit_count = Math.max(1, $scope.model.rule.minimum_hit_count) || 1;
                }
                if ($scope.model.saas === 'slack' && feature.enableSlackFeatures && feature.enableSlackSelectEntities) {
                    rule.rule.selected_entities = $scope.internal.selectedEntities;
                }
            }
            if ($scope.ruleTypeConfig.activeSecTypes.anomaly) {
                if (!$scope.model.rule.all_anomalies && (!$scope.internal.selectedAnomalies || !$scope.internal.selectedAnomalies.length)) {
                    modals.alert('Please select at least one anomaly type', { title: 'Error' });
                    return;
                }
                rule.rule.all_anomalies = $scope.model.rule.all_anomalies || false;
                if (rule.rule.all_anomalies) {
                    rule.rule.excluded_anomalies = [];
                } else {
                    rule.rule.excluded_anomalies = _($scope.anomalyTypes).chain().pluck('id').filter(function (id) {
                        return !$scope.internal.selectedAnomalies || !_($scope.internal.selectedAnomalies).includes(id);
                    }).value();
                }
            }
            var workflows = {};
            var workflowMissingConfig = false;
            var foundEncryptionWorkflow = false;
            _($scope.workflows).each(function (workflow) {
                if ($scope.workflowAvailable(workflow)) {
                    if (workflow.id === 'threat_extraction_workflow' && !$scope.internal.workflows.threat_extraction_mode) {
                        return;
                    }
                    workflows[workflow.id] = $scope.internal.workflows[workflow.id];
                    if (feature.enableOneClickEncryption && $scope.model.saas === 'office365_emails' && $scope.model.ruleType === 'dlp' && !$scope.disableEncryptionWorkflowModal && workflows[workflow.id].indexOf('_encryption') !== -1) {
                        foundEncryptionWorkflow = true;
                    }
                    if (!workflowMissingConfig && workflowsMissingConfig[workflow.id][workflows[workflow.id]]) {
                        workflowMissingConfig = {
                            workflow: workflow,
                            error: workflowsMissingConfig[workflow.id][workflows[workflow.id]]
                        };
                    }
                    if ($scope.showStaticPhishing[workflow.id][workflows[workflow.id]]) {
                        rule.rule.static_phishing = $scope.model.rule.static_phishing;
                    }
                }
            });
            if (workflowMissingConfig) {
                return modals.confirm({
                    title: 'Invalid configuration',
                    message: workflowMissingConfig.error,
                    okText: 'Configure',
                    cancelText: 'Cancel'
                }).then(function () {
                    return appConfigurator.configureApp($scope.model.saas);
                }).then(function (configResponse) {
                    return onConfigChanged(configResponse);
                }).then(function () {
                    $scope.savingConfig = false;
                    $scope.savingConfigTip = {};
                    return $scope.save();
                });
            }
            if (!_(workflows).isEmpty()) {
                rule.rule.workflows = workflows;
            }
            var ruleError = checkRuleErrors(rule);
            if (ruleError !== '') {
                return modals.alert(ruleError, { title: 'Error' });
            }
            if ($scope.model.saas === 'office365_emails' && $scope.model.mode === 'inline') {
                rule.rule.manual_inline_rule = $scope.model.rule.manual_inline_rule;
            }
            if ($scope.enableProtectOutgoingEmails) {
                rule.rule.protect_outgoing_emails = $scope.model.rule.protect_outgoing_emails;
            }
            if ($scope.ruleTypeConfig.showSkipInternal) {
                rule.rule.skip_internal = $scope.model.rule.skip_internal;
            }
            if (_(rule.identity.groups).isEmpty() && _(rule.identity.users).isEmpty() && !$scope.model.all) {
                // p = p.then(function () {
                //     return modals.confirm({
                //         title: 'Warning',
                //         message: 'You are about to save a rule with no selected users/ groups.<br />' +
                //         'Default behavior is to apply rule on all users.<br />' +
                //         'If this was not your intention - please return to user selector and pick users to apply rule on.<br />' +
                //         'Otherwise, click "Continue".',
                //         okText: 'Continue',
                //         cancelText: 'Cancel'
                //     });
                // });
                $scope.loading = false;
                return modals.alert('You can not save policy with no selected users', { title: 'Warning' });
            }
            if (displayLimitedLicensePopupFor.includes($scope.model.saas)) {
                if (sideMenuManager.limitedLicense() && $scope.model.licenses && $scope.model.all) {
                    p = p.then(function () {
                        return modals.confirm({
                            title: 'Warning',
                            message: 'You\'re running on a limited license. Unlicensed users will ' + '<strong>not</strong> be protected. Please go to ' + '<a class="manual-mailflow-doc" href="' + $scope.model.redirectToLicenseConfig + '"><strong>license configuration screen</strong></a>' + ' to reassign licenses to users.',
                            okText: 'Continue',
                            cancelText: 'Cancel',
                            windowClass: 'inline-user-limit-dialog'
                        });
                    });
                }
            }
            if (rule.type === 'access_control') {
                rule.rule.allow_countries = $scope.model.rule.allow_countries || [];
                rule.rule.allow_ips = $scope.model.rule.allow_ips || [];
                rule.rule.block_countries = $scope.model.rule.block_countries || [];
                rule.rule.block_ips = $scope.model.rule.block_ips || [];
                rule.rule.devices = $scope.model.rule.devices;
            }
            var found412Error = false;
            if ($scope.model.saas === 'office365_emails' && $scope.model.mode === 'inline' && isUsers && isGroups) {
                return modals.confirm({
                    title: 'Warning',
                    okText: 'Continue',
                    cancelText: 'Cancel',
                    message: 'Dear user,<br />' + 'The policy has one or more Office 365 email rules ' + 'in inline mode with scope that includes both groups and users. ' + 'This may cause a performance problem in Office 365.<br />' + 'Therefore, it is recommended that all inline modes ' + 'scopes includes either groups-only or users-only.'
                }).then(function () {
                    $scope.loading = true;
                    rule.ignore_mixed_warning = 1;
                    return saveRule(rule);
                }).then(function () {
                    savedPolicy({ foundEncryptionWorkflow: foundEncryptionWorkflow });
                }, function (err) {
                    return processRejection(err, found412Error, rule, foundEncryptionWorkflow);
                });
            }
            if ($scope.enableIgnoreLowConfidenceResults) {
                rule.rule.ignore_low_confidence_results = $scope.internal.ignoreLowConfidenceResults;
            }
            return p.then(function () {
                $scope.loading = true;
                return saveRule(rule, foundEncryptionWorkflow);
            }).then(function () {
                savedPolicy({ foundEncryptionWorkflow: foundEncryptionWorkflow });
            }, function (err) {
                return processRejection(err, found412Error, rule, foundEncryptionWorkflow);
            }).then(function () {
                if (found412Error) {
                    rule.ignore_mixed_warning = 1;
                    return saveRule(rule);
                }
            }).then(function () {
                if (found412Error) {
                    savedPolicy({ foundEncryptionWorkflow: foundEncryptionWorkflow });
                }
            }, function () {
                $scope.loading = false;
            });
        };
        function onConfigChanged(configResponse) {
            return saasConfigConverter(configResponse).then(function () {
                var queries = [loadActions($scope.model.saas, true)];
                if ($scope.ruleTypeConfig.workflows) {
                    queries.push(loadWorkflows($scope.model.saas, configResponse));
                }
                return $q.all(queries);
            });
        }
        function enabledActions(actions) {
            return _(actions).reduce(function (memo, action, actionId) {
                if (action.enabled) {
                    memo.push(actionId);
                }
                return memo;
            }, []);
        }
        function uncheckConflictingActions(enabled) {
            _(enabled).each(function (actionId) {
                if (!$scope.internal.actions[actionId] || !$scope.internal.actions[actionId].enabled) {
                    return;
                }
                var info = $scope.actionsMap[actionId];
                if (!info.conflicting_actions) {
                    return;
                }
                _(info.conflicting_actions).each(function (id) {
                    if ($scope.internal.actions[id] && $scope.internal.actions[id].enabled) {
                        $scope.internal.actions[id].enabled = false;
                    }
                });
            });
        }
        function setConflictingActionTip() {
            _($scope.actions).each(function (action) {
                if (!action.conflicting_actions) {
                    return;
                }
                var tip = '';
                var conflictingLabels = _(action.conflicting_actions).chain().filter(function (id) {
                    return $scope.internal.actions[id] && $scope.internal.actions[id].enabled;
                }).map(function (id) {
                    return $scope.actionsMap[id].label;
                }).value();
                if (conflictingLabels.length) {
                    var label = _(conflictingLabels).chain().reverse().map(function (label, idx) {
                        var ret = '<strong>' + label + '</strong>';
                        if (idx === 1) {
                            ret += ' and ';
                        }
                        if (idx > 1) {
                            ret += ', ';
                        }
                        return ret;
                    }).reverse().value().join('');
                    tip = 'This action can\'t be used together with ' + label + '.<br />If you select this action incompatible actions will be un-selected';
                }
                action.tip = tip;
            });
        }
        $scope.$watch('internal.actions', function (newValue, oldValue) {
            var enabled = enabledActions($scope.internal.actions);
            var oldEnabled = enabledActions(oldValue);
            var justEnabled = _(enabled).difference(oldEnabled);
            uncheckConflictingActions(justEnabled);
            uncheckConflictingActions(enabledActions($scope.internal.actions));
            setConflictingActionTip();
        }, true);
        $scope.$on('module-config-changed', function (event, data) {
            if (data && data.module === $scope.model.saas) {
                onConfigChanged();
            }
        });
        $scope.$on('saving-config', function () {
            $scope.savingConfig = true;
            $scope.savingConfigTip = {
                content: { text: 'Saving config...' },
                position: {
                    at: 'top center',
                    my: 'bottom center'
                },
                style: { classes: 'qtip-standard' }
            };
        });
        $scope.$on('saving-config-done', function () {
            $scope.savingConfig = false;
        });
        var tempSelectedScope;
        $scope.allScopesCheckChange = function () {
            if ($scope.model.all) {
                tempSelectedScope = angular.copy($scope.model.scopes);
                $scope.model.scopes = [];
            } else {
                if (tempSelectedScope) {
                    $scope.model.scopes = tempSelectedScope;
                }
            }
            reloadIdentities();
        };
    }]);
}());